module.exports = __webpack_public_path__ + "img/16.8c26e7ab.png";